export enum GameDetailRouteName {
  Detail = 'game-detail',
  Quests = 'game-quests',
  Entities = 'game-entities',
  PlayersList = 'game-players-list',
  Statistics = 'game-statistics',
}
